// Port of api/fuel/app/classes/controller/api/monty/listing/filter.php
import DB from 'offline/db'
import {
	LIST_TYPE_AUTOMATED,
	currentUserId,
	loadOwnedListing,
	persist,
	unauthorised
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)

	if (!userId) return unauthorised()
	if (!listing || listing.get_template() || listing.get_type() !== LIST_TYPE_AUTOMATED) return unauthorised()

	DB.run('UPDATE list SET list_filter = ? WHERE list_id = ?', [
		JSON.stringify(params.filter || {}),
		listing.get_id()
	])

	return persist(loadOwnedListing(userId, listing.get_id()).to_array())
}
